import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { SelectOptionsService } from '@app/shared/services/select-options.service'

@Component({
  selector: 'app-agreement-part-form',
  templateUrl: './agreement-part-form.component.html'
})

export class AgreementPartFormComponent implements OnInit, OnDestroy {

  /**
   * Display page
   */
  public display: boolean

  /**
   * Heading text
   */
  @Input() fixedType: boolean

  /**
   * Main form
   */
  @Input() mainForm: FormGroup

  /**
   * Main form change
   */
  @Output() mainFormChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()

  public currentOpportunityAgreementForm: FormGroup

  /**
   * Constructor
   */
  public constructor (
    public selectOptionsService: SelectOptionsService
  ) {}

  /**
   * On destroy
   */
  public ngOnDestroy (): void {}

  /**
   * On init
   */
  public ngOnInit (): void {
    this.display = true
  }

}
